import { gql } from "@apollo/client";

export const GET_FULFILLMENT_RULES = gql`
  query getFulfillmentRules(
    $offset: Int = 0
    $limit: Int = 100
    $sort: String = "name"
    $showDeleted: Boolean = false
  ) {
    getFulfillmentRules(
      offset: $offset
      limit: $limit
      sort: $sort
      showDeleted: $showDeleted
    ) {
      total
      items {
        id
        name
        description
        programId
        mode
        minWaitDays
        maxWaitDays
        minRewardOrders
        isDeleted
        createdDate
      }
    }
  }
`;

export const GET_FULFILLMENT_RULES_SHORT = gql`
  query getFulfillmentRules(
    $offset: Int = 0
    $limit: Int = 100
    $sort: String
    $showDeleted: Boolean
  ) {
    getFulfillmentRules(
      offset: $offset
      limit: $limit
      sort: $sort
      showDeleted: $showDeleted
    ) {
      total
      items {
        id
        name
      }
    }
  }
`;

export const GET_FULFILLMENT_RULE = gql`
  query getFulfillmentRule($id: ID!) {
    getFulfillmentRule(ruleId: $id) {
      id
      name
      description
      programId
      mode
      minWaitDays
      maxWaitDays
      minRewardOrders
      isDeleted
      createdDate
    }
  }
`;

export const CREATE_FULFILLMENT_RULE = gql`
  mutation createFulfillmentRule($input: FulfillmentRuleInput!) {
    createFulfillmentRule(input: $input) {
      id
      name
      description
      programId
      mode
      minWaitDays
      maxWaitDays
      minRewardOrders
      isDeleted
      createdDate
    }
  }
`;

export const UPDATE_FULFILLMENT_RULE = gql`
  mutation updateFulfillmentRule($ruleId: ID!, $input: FulfillmentRuleInput!) {
    updateFulfillmentRule(ruleId: $ruleId, input: $input) {
      id
      name
      description
      programId
      mode
      minWaitDays
      maxWaitDays
      minRewardOrders
      isDeleted
      createdDate
    }
  }
`;

export const DELETE_FULFILLMENT_RULE = gql`
  mutation deleteFulfillmentRule($ruleId: ID!) {
    deleteFulfillmentRule(ruleId: $ruleId)
  }
`;
